import React, { useEffect, useState } from "react";
import { loadAllBarsWeek } from "../shared/barStats";

// Admin: what customers did with each bar in the last 7 days.
export default function ActivityTable() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    loadAllBarsWeek()
      .then((r) => setRows(r.sort((a, b) => b.opened - a.opened || b.seen - a.seen)))
      .catch((e) => setError(e.message));
  }, []);

  const th = { textAlign: "right", padding: "8px 10px", color: "#B8B0C8", fontWeight: 600, fontSize: "14px", whiteSpace: "nowrap" };
  const td = { textAlign: "right", padding: "8px 10px", fontSize: "15px" };

  const totals = (rows || []).reduce(
    (t, r) => ({ seen: t.seen + r.seen, opened: t.opened + r.opened, taps: t.taps + r.calls + r.directions + r.website, saves: t.saves + r.saves, offers: t.offers + r.offersUsed }),
    { seen: 0, opened: 0, taps: 0, saves: 0, offers: 0 }
  );

  return (
    <div style={{ background: "#0D0B1A", padding: "20px", borderRadius: "12px", marginBottom: "24px" }}>
      <h3 style={{ margin: "0 0 4px" }}>Customer activity, last 7 days</h3>
      <p style={{ margin: "0 0 14px", color: "#B8B0C8" }}>
        Totals only. Counting started when this feature went live.
      </p>
      {error && <p style={{ color: "#FF6B8A" }}>{error}</p>}
      {!rows && !error && <p style={{ color: "#B8B0C8" }}>Loading…</p>}
      {rows && rows.length === 0 && <p style={{ color: "#B8B0C8" }}>No activity recorded yet.</p>}
      {rows && rows.length > 0 && (
        <>
          <p style={{ margin: "0 0 12px" }}>
            <strong>{totals.seen}</strong> bar views · <strong>{totals.opened}</strong> pages opened ·{" "}
            <strong>{totals.taps}</strong> calls/directions/website · <strong>{totals.saves}</strong> saves ·{" "}
            <strong>{totals.offers}</strong> offers used
          </p>
          <div style={{ overflowX: "auto", maxHeight: "480px", overflowY: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "640px" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #241E33" }}>
                  <th style={{ ...th, textAlign: "left" }}>Bar</th>
                  <th style={th}>Seen</th>
                  <th style={th}>Opened</th>
                  <th style={th}>Calls</th>
                  <th style={th}>Directions</th>
                  <th style={th}>Website</th>
                  <th style={th}>Saves</th>
                  <th style={th}>Offers used</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.barId} style={{ borderBottom: "1px solid #17131F" }}>
                    <td style={{ ...td, textAlign: "left" }}>{r.barName || r.barId}</td>
                    <td style={td}>{r.seen}</td>
                    <td style={td}>{r.opened}</td>
                    <td style={td}>{r.calls}</td>
                    <td style={td}>{r.directions}</td>
                    <td style={td}>{r.website}</td>
                    <td style={td}>{r.saves}</td>
                    <td style={td}>{r.offersUsed}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
